export default "__VITE_ASSET__DM1cOF22__"